import { identity } from 'ramda';

import { GamesInfoPopup } from 'js/app/components/popups/GamesInfoPopup/GamesInfoPopup';
import { addPopupAction, closePopupAction, LAYER } from 'js/components/common/PopupManager';

import { GAMES_INFO_POPUP_ID } from 'js/app/components/popups/GamesInfoPopup/constants';
import { SINGLETON_MODE } from 'js/components/common/PopupManager/constants';

export const closeGameInfoPopup = () => closePopupAction(GAMES_INFO_POPUP_ID);

export const showGameInfoPopup = ({ gameCode, navigationDirection, onClose = identity }) => {
    return addPopupAction({
        id: GAMES_INFO_POPUP_ID,
        component: GamesInfoPopup,
        layer: LAYER.GAMES_INFO,
        addFirst: navigationDirection === -1,
        singletonMode: SINGLETON_MODE.UPDATE,
        onClose,
        gameCode
    });
};
